var map = {
	"./beauty-01.jpg": 3673,
	"./beauty-02.jpg": 5719,
	"./beauty-03.jpg": 9724,
	"./beauty-04.jpg": 390,
	"./buffet-01.jpg": 7715,
	"./buffet-02.jpg": 2361,
	"./buffet-03.jpg": 3240,
	"./buffet-04.jpg": 9943,
	"./buffet-05.jpg": 4104,
	"./buffet-06.jpg": 9153,
	"./cigar-01.jpg": 7809,
	"./cigar-02.jpg": 3732,
	"./cigar-03.jpg": 4835,
	"./cigar-04.jpg": 1855,
	"./cigar-05.jpg": 6789,
	"./draw-1.jpg": 7718,
	"./draw-2.jpg": 4955,
	"./draw-3.jpg": 84,
	"./draw-4.jpg": 6156,
	"./draw-5.jpg": 945,
	"./habitacion-1.jpg": 8352,
	"./habitacion-2.jpg": 787,
	"./habitacion-3.jpg": 2583,
	"./habitacion-4.png": 1196,
	"./habitacion-5.png": 8691,
	"./hallway-1.jpg": 2048,
	"./hallway-2.jpg": 7958,
	"./hallway-3.jpg": 4296,
	"./hotel-room-design-01.jpg": 5808,
	"./hotel-room-design-02.jpg": 17,
	"./hotel-room-design-03.jpg": 3159,
	"./hotel-room-design-04.jpg": 7545,
	"./hotel-room-design-05.jpg": 5717,
	"./hotel-room-design-06.jpg": 5561,
	"./italian-01.jpg": 1171,
	"./italian-02.jpg": 5,
	"./italian-03.jpg": 7222,
	"./italian-04.jpg": 4692,
	"./italian-05.jpg": 2775,
	"./italian-06.jpg": 215,
	"./logo-01.jpg": 9318,
	"./logo-02.jpg": 9230,
	"./logo-03.png": 3108,
	"./logo-04.jpg": 998,
	"./market-1.jpg": 9130,
	"./market-2.jpg": 4819,
	"./market-3.jpg": 3075,
	"./market-4.jpg": 2714,
	"./market-5.jpg": 2910,
	"./market-6.jpg": 618,
	"./market-7.jpg": 2171,
	"./outdoor-design-01.png": 8908,
	"./outdoor-design-02.jpg": 1600,
	"./outdoor-design-03.jpg": 2074,
	"./outdoor-design-04.jpg": 8211,
	"./outdoor-design-05.jpg": 6799,
	"./outdoor-restaurant-01.png": 4736,
	"./outdoor-restaurant-02.jpg": 4199,
	"./outdoor-restaurant-03.jpg": 7651,
	"./outdoor-restaurant-04.jpg": 9798,
	"./outdoor-restaurant-05.jpg": 4369,
	"./outdoor-restaurant-06.jpg": 4825,
	"./outdoor-restaurant-07.jpg": 1837,
	"./outdoor-restaurant-08.jpg": 4973,
	"./piano-01.jpg": 5418,
	"./piano-02.jpg": 9829,
	"./piano-03.jpg": 9089,
	"./piano-04.jpg": 6849,
	"./piano-05.jpg": 7110,
	"./snack-01.jpg": 7336,
	"./snack-02.jpg": 917,
	"./snack-03.jpg": 7012,
	"./snack-04.jpg": 2458,
	"./snack-05.jpg": 5902,
	"./snack-06.jpg": 8745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7895;